
export default () => ({
    loading: true,
    points: [],
    currentPoint: null
})
